import { isEnumMember } from '../../../helpers/types'
import {
  DateMatch,
  DateTimeMatch,
  NumericMatch,
  TextMatch,
  TrackingMatch,
} from '../../../types/FilterCondition'
import {
  type UiDeviceSpec,
  type UiEngagementSpec,
  type UiFilterCondition,
  type UiFilterDetail,
  type UiGeoSpec,
  type UiGroupSpec,
  type UiProfileSpec,
  type UiTrackingSpec,
} from '../filterConditionTypes'
import {
  validateUiDateSpec,
  validateUiDateTimeSpec,
  validateUiNumericSpec,
  validateUiTextSpec,
} from './profileFieldSpecValidation'

export const validateUiGroupCondition = (
  cond: UiFilterCondition,
  filter: UiFilterDetail,
): boolean => {
  const spec = cond.Spec as UiGroupSpec
  return filter.IdList !== 0 && spec?.Values?.length > 0
}

export const validateProfileFieldCondition = (
  ui: UiFilterCondition,
): boolean => {
  const uiSpec = ui.Spec as UiProfileSpec

  if (isEnumMember<TextMatch>(uiSpec.Match, TextMatch)) {
    return validateUiTextSpec(uiSpec)
  }
  if (isEnumMember<NumericMatch>(uiSpec.Match, NumericMatch)) {
    return validateUiNumericSpec(uiSpec)
  }
  if (isEnumMember<DateMatch>(uiSpec.Match, DateMatch)) {
    return validateUiDateSpec(uiSpec)
  }
  if (isEnumMember<DateTimeMatch>(uiSpec.Match, DateTimeMatch)) {
    return validateUiDateTimeSpec(uiSpec)
  }
  return false
}

export const validateUiEngagementCondition = (
  ui: UiFilterCondition,
): boolean => {
  const uiSpec = ui.Spec as UiEngagementSpec

  return uiSpec.Value !== undefined
}

export const validateUiGeoCondition = (ui: UiFilterCondition): boolean => {
  const uiSpec = ui.Spec as UiGeoSpec

  return (
    ['LocatedIn', 'NotLocatedIn'].includes(uiSpec.GeoMatchOperator) &&
    [1, 2, 3].includes(uiSpec.Precision) &&
    uiSpec.Country.length > 0
  )
}

export const validateUiDeviceCondition = (ui: UiFilterCondition): boolean => {
  const uiSpec = ui.Spec as UiDeviceSpec

  return uiSpec.Value !== undefined
}

export const validateUiTrackingCondition = (ui: UiFilterCondition): boolean => {
  const spec = ui.Spec as UiTrackingSpec

  if (
    typeof spec.TrackingActive !== 'boolean' ||
    !isEnumMember<TrackingMatch>(spec.TrackingMatchOperator, TrackingMatch)
  ) {
    return false
  }

  if (spec.TrackingMatchOperator === TrackingMatch.TrackingAnytime) {
    return true
  }

  const dates = spec.Dates?.Details
  return dates?.From instanceof Date && dates.To instanceof Date
}
